import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";
import { getPatComplete } from "../utils/context-utils";
import FootballState from "../state/football-state";

export default class EndOfPlay extends Fragment {
    summarize(summaryContext, stringifier, play) {
        let message = "";
        if (this.isValidPat(play)) {
            const offensePatComplete = getPatComplete(
                summaryContext,
                play.contextSnapshot,
                play
            );
            message += offensePatComplete ? "succeeded" : "failed";
            if (!offensePatComplete) {
                const modifiedSnapshot = {
                    ...play.contextSnapshot,
                    homeTeamHasPossession:
                        !play.contextSnapshot.homeTeamHasPossession
                };
                const defensePatComplete = getPatComplete(
                    summaryContext,
                    modifiedSnapshot,
                    play
                );
                message = defensePatComplete ? "defense succeeded" : message;
            }
        }
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext, play) {
        if (this.isValidPat(play)) {
            summaryContext.eopPrinted = true;
        }
    }

    getTimeAndPeriod() {
        return this.time;
    }

    isValidPat(play) {
        const isPatPlay = play?.historyContains(FootballState.PatTry);
        const hasPatFragment = [
            FootballState.PatCompleted,
            FootballState.PatMissed,
            FootballState.PatFumbled,
            FootballState.PatIntercepted,
            FootballState.PatBlocked
        ].some((state) => play?.historyContains(state));

        return isPatPlay && !hasPatFragment;
    }
}
